/*
  ============================================================
  levili-fit.js — enquadra o TÊNIS (e não a imagem) nas vitrines
  ============================================================

  O QUE FAZ:
  Fotos de produto chegam de jeitos diferentes: recortadas rente ao tênis
  ou quadradas com muita sobra em volta (fundo transparente ou branco).
  O CSS só sabe encaixar a imagem inteira, então a sobra deixa o tênis
  pequeno. Este script mede, em cada foto, a área que o tênis realmente
  ocupa (pixels não transparentes / não brancos) e aplica `scale` +
  `translate` para que o tênis preencha a caixa da imagem como se a foto
  tivesse sido recortada rente. Fotos com fundo colorido não mudam.

  ONDE AGE: as imagens com as classes de FIT_SELECTOR (topo, torre de
  categorias, vitrine, destaque, cards e foto principal do produto).

  DETALHES:
  - A medição é feita uma vez por foto, numa cópia pequena (160 px), e
    guardada em cache. Se o navegador não deixar ler os pixels (imagem de
    outro domínio sem CORS), a foto fica como está.
  - O `transform-origin` vai para o centro do tênis, então o `rotate` que
    as seções já usam continua girando o tênis em torno dele mesmo.
  - Recalcula quando a imagem carrega, quando a caixa muda de tamanho e
    quando seções novas entram na página (filtros, carrinho, editor).
*/
(function () {
  'use strict';

  var FIT_SELECTOR = '.lv-hero__shoe-img, .lv-cat__img, .lv-vit__img, .lv-dest__img, .card__img, .lv-pdp__img';
  var FILL = 0.96; // quanto da caixa o tênis ocupa (sobra de 4% para a sombra)
  var MAX_SCALE = 2.6; // nunca amplia mais que isso
  var SAMPLE = 160; // largura da cópia usada para medir

  var cache = {}; // src -> { x0, y0, x1, y1 } em fração da imagem, ou null (não mexer)
  var pending = {}; // src -> [callbacks]

  function srcKey(img) {
    var s = img.currentSrc || img.src || '';
    return s.split('#')[0];
  }

  function isWhite(r, g, b) { return r > 236 && g > 236 && b > 236; }

  // Fundo branco -> transparente: apaga só o branco ligado às bordas da foto
  // (flood fill), então o branco DENTRO do tênis fica. Borda suavizada.
  var CUT_MAX = 1000; // largura máxima do recorte (px)
  var T = 26; // tolerância: quão "quase branco" conta como fundo
  function cutWhite(probe, cb) {
    var sc = Math.min(1, CUT_MAX / probe.naturalWidth);
    var w = Math.max(1, Math.round(probe.naturalWidth * sc));
    var h = Math.max(1, Math.round(probe.naturalHeight * sc));
    var c = document.createElement('canvas');
    c.width = w; c.height = h;
    var g = c.getContext('2d', { willReadFrequently: true });
    g.drawImage(probe, 0, 0, w, h);
    var img = g.getImageData(0, 0, w, h);
    var d = img.data;
    var n = w * h;
    var bgMask = new Uint8Array(n);
    var stack = new Int32Array(n);
    var sp = 0;
    var cand = function (p) {
      var i = p * 4;
      var mn = Math.min(d[i], d[i + 1], d[i + 2]);
      return 255 - mn <= T;
    };
    var push = function (p) { if (!bgMask[p] && cand(p)) { bgMask[p] = 1; stack[sp++] = p; } };
    for (var x = 0; x < w; x++) { push(x); push((h - 1) * w + x); }
    for (var y = 0; y < h; y++) { push(y * w); push(y * w + w - 1); }
    while (sp) {
      var p = stack[--sp];
      var px = p % w;
      if (px > 0) push(p - 1);
      if (px < w - 1) push(p + 1);
      if (p >= w) push(p - w);
      if (p < n - w) push(p + w);
    }
    var removed = 0, x0 = w, y0 = h, x1 = -1, y1 = -1;
    for (var q = 0; q < n; q++) {
      var i = q * 4;
      if (bgMask[q]) { d[i + 3] = 0; removed++; continue; }
      // borda: pixel claro vizinho do fundo ganha transparência parcial
      var qx = q % w;
      var nearBg = (qx > 0 && bgMask[q - 1]) || (qx < w - 1 && bgMask[q + 1]) || (q >= w && bgMask[q - w]) || (q < n - w && bgMask[q + w]);
      if (nearBg) {
        var light = 255 - Math.min(d[i], d[i + 1], d[i + 2]);
        if (light < T * 3) d[i + 3] = Math.round(255 * light / (T * 3));
      }
      var qy = (q - qx) / w;
      if (qx < x0) x0 = qx; if (qx > x1) x1 = qx;
      if (qy < y0) y0 = qy; if (qy > y1) y1 = qy;
    }
    // Recorte suspeito (sumiu quase tudo ou quase nada): deixa a foto como está
    if (x1 < 0 || removed > n * 0.95 || removed < n * 0.08) return cb(null);
    g.putImageData(img, 0, 0);
    c.toBlob(function (blob) {
      if (!blob) return cb(null);
      var url = URL.createObjectURL(blob);
      var box = { x0: x0 / w, y0: y0 / h, x1: (x1 + 1) / w, y1: (y1 + 1) / h, ratio: w / h, bg: 'alpha' };
      cache[url] = box;
      cb({ url: url, box: box });
    }, 'image/png');
  }

  function measure(src, done) {
    if (Object.prototype.hasOwnProperty.call(cache, src)) return done(cache[src]);
    if (pending[src]) return pending[src].push(done);
    pending[src] = [done];
    var finish = function (box) {
      cache[src] = box;
      var cbs = pending[src] || [];
      delete pending[src];
      cbs.forEach(function (cb) { cb(box); });
    };
    if (/\.svg(\?|$)/i.test(src) || src.indexOf('data:') === 0) return finish(null);
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.decoding = 'async';
    probe.onload = function () {
      try {
        var w = SAMPLE;
        var h = Math.max(1, Math.round(SAMPLE * probe.naturalHeight / probe.naturalWidth));
        var c = document.createElement('canvas');
        c.width = w; c.height = h;
        var g = c.getContext('2d', { willReadFrequently: true });
        g.drawImage(probe, 0, 0, w, h);
        var d = g.getImageData(0, 0, w, h).data;
        // Fundo: transparente? branco nos 4 cantos? (senão, não mexe)
        var hasAlpha = false;
        for (var k = 3; k < d.length; k += 16) { if (d[k] < 245) { hasAlpha = true; break; } }
        var whiteBg = false;
        if (!hasAlpha) {
          var corners = [0, (w - 1) * 4, (h - 1) * w * 4, ((h - 1) * w + w - 1) * 4];
          whiteBg = corners.every(function (i) { return isWhite(d[i], d[i + 1], d[i + 2]); });
          if (!whiteBg) return finish(null);
          // Fundo branco: recorta e devolve a versão transparente
          return cutWhite(probe, function (res) {
            if (!res) return finish(null);
            var b = {}; for (var key in res.box) b[key] = res.box[key];
            b.bg = 'white'; b.cut = res.url;
            finish(b);
          });
        }
        var x0 = w, y0 = h, x1 = -1, y1 = -1;
        for (var y = 0; y < h; y++) {
          for (var x = 0; x < w; x++) {
            var i = (y * w + x) * 4;
            var on = hasAlpha ? d[i + 3] > 24 : !isWhite(d[i], d[i + 1], d[i + 2]);
            if (on) {
              if (x < x0) x0 = x; if (x > x1) x1 = x;
              if (y < y0) y0 = y; if (y > y1) y1 = y;
            }
          }
        }
        if (x1 < 0) return finish(null);
        finish({ x0: x0 / w, y0: y0 / h, x1: (x1 + 1) / w, y1: (y1 + 1) / h, ratio: probe.naturalWidth / probe.naturalHeight, bg: hasAlpha ? 'alpha' : 'white' });
      } catch (e) {
        finish(null); // pixels bloqueados (CORS) ou erro de leitura
      }
    };
    probe.onerror = function () { finish(null); };
    probe.src = src;
  }

  function reset(img) {
    img.style.removeProperty('scale');
    img.style.removeProperty('translate');
    img.style.removeProperty('transform-origin');
    img.removeAttribute('data-fit');
  }

  function clear(img) {
    reset(img);
    img.removeAttribute('data-fit-bg');
  }

  function apply(img, box) {
    if (!box) return clear(img);
    img.setAttribute('data-fit-bg', box.bg);
    if (box.cut) {
      // troca pela versão sem fundo; o 'load' dela chama o enquadramento de novo
      if (img.src !== box.cut) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = box.cut;
      }
      return;
    }
    var W = img.clientWidth, H = img.clientHeight;
    if (!W || !H) return;
    // Retângulo do conteúdo dentro da caixa (object-fit: contain, centralizado)
    var fit = getComputedStyle(img).objectFit;
    var cw = W, ch = H;
    if (fit === 'contain' || fit === 'scale-down') {
      if (W / H > box.ratio) { ch = H; cw = H * box.ratio; } else { cw = W; ch = W / box.ratio; }
    }
    var ox = (W - cw) / 2, oy = (H - ch) / 2;
    var bx0 = ox + box.x0 * cw, by0 = oy + box.y0 * ch;
    var bw = (box.x1 - box.x0) * cw, bh = (box.y1 - box.y0) * ch;
    if (bw < 2 || bh < 2) return reset(img);
    // No destaque os dois tênis dividem a cena com a palavra gigante: ocupam menos
    var fill = img.classList.contains('lv-dest__img') ? 0.8 : img.classList.contains('lv-pdp__img') ? 0.9 : FILL;
    var s = Math.min(W / bw, H / bh) * fill;
    if (s > MAX_SCALE) s = MAX_SCALE;
    if (s < 1.04) return reset(img); // já está enquadrado
    var cx = bx0 + bw / 2, cy = by0 + bh / 2;
    img.style.transformOrigin = cx.toFixed(1) + 'px ' + cy.toFixed(1) + 'px';
    img.style.scale = s.toFixed(3);
    img.style.translate = (W / 2 - cx).toFixed(1) + 'px ' + (H / 2 - cy).toFixed(1) + 'px';
    img.setAttribute('data-fit', s.toFixed(2));
  }

  var ro = 'ResizeObserver' in window ? new ResizeObserver(function (entries) {
    entries.forEach(function (en) { var img = en.target; var b = cache[srcKey(img)]; if (b !== undefined) apply(img, b); });
  }) : null;

  function fitImg(img) {
    if (img.__lvFit === srcKey(img) && img.complete) return;
    var run = function () {
      var src = srcKey(img);
      if (!src) return;
      img.__lvFit = src;
      measure(src, function (box) { apply(img, box); });
    };
    if (!img.__lvBound) {
      img.__lvBound = true;
      img.addEventListener('load', function () { img.__lvFit = null; run(); });
      if (ro) ro.observe(img);
    }
    if (img.complete && img.naturalWidth) run();
  }

  function scan(root) {
    (root || document).querySelectorAll(FIT_SELECTOR).forEach(fitImg);
  }

  function init() {
    scan();
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 80); })
      .observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.LeviliFit = { scan: scan };
})();
